import { Injectable } from '@angular/core';
import { base64ToDataUrl, Video } from '@caballus/ui-common';
import { Photo } from '@capacitor/camera';
import { Observable, of, Subject, Subscriber, Subscription } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ThumbnailService {
    constructor() {}

    public getPhotoThumbnail(photo: Photo, height: number, width: number): Observable<string> {
        return new Observable((subscriber: Subscriber<string>): (() => void) => {
            const onComplete: Subject<void> = new Subject();

            let image = new Image();

            let canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            image.onload = (): Subscription =>
                of(undefined)
                    .pipe(
                        takeUntil(onComplete),
                        tap(() => {
                            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                        }),
                        map(() => canvas.toDataURL())
                    )
                    .subscribe(thumbnail => subscriber.next(thumbnail));
            image.src = photo.base64String ? base64ToDataUrl(photo.base64String) : photo.dataUrl;

            return (): void => {
                image = undefined;
                canvas = undefined;
                onComplete.next();
                onComplete.complete();
            };
        });
    }

    public getVideoThumbnail(v: Video, height: number, width: number): Observable<string> {
        return new Observable((subscriber: Subscriber<string>): (() => void) => {
            const onComplete: Subject<void> = new Subject();
            let canvas = document.createElement('canvas');
            let video = document.createElement('video');
            video.style.display = 'none';
            canvas.style.display = 'none';

            canvas.width = width;
            canvas.height = height;
            // // this is important
            video.autoplay = true;
            video.muted = true;
            video.preload = 'metadata';

            const ctx = canvas.getContext('2d');

            v.blob().then(file => {
                video.onloadeddata = (): Subscription =>
                    of(file)
                        .pipe(
                            take(1),
                            takeUntil(onComplete),
                            tap(() => {
                                video.currentTime = 0.2;

                                canvas.width = video.videoWidth;
                                canvas.height = video.videoHeight;

                                ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
                            }),
                            map(() => canvas.toDataURL('image/png'))
                        )
                        .subscribe(
                            (thumbnail) => {
                                video.pause();
                                const urls = {
                                    thumbnailDataUrl: thumbnail,
                                    dataUrl: URL.createObjectURL(file as File)
                                };
                                subscriber.next(JSON.stringify(urls));
                            },
                        );

                video.src = URL.createObjectURL(new Blob([file], { type: 'video/mp4' }));
                video.onerror = (event, source, lineno, colno, error) => {
                };
                return '';
            });
            return (): void => {
                video = undefined;
                canvas = undefined;
                onComplete.next();
                onComplete.complete();
            };
        });
    }
}
